import { useMemo, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./DokuTenantSelect.css";

// Eingabetext und bestätigte Auswahl bleiben getrennt. Blur übernimmt keinen Vorschlag.
export default function DokuTenantSelect({ id, label, placeholder, options, value, onChange, disabled, loading, title }) {
  const { t } = useTranslation("doku");
  const [input, setInput] = useState("");
  const selectedLabel = options.find(option => option.id === value)?.label;
  const selected = useMemo(() => selectedLabel === undefined ? null : { id: value, label: selectedLabel }, [value, selectedLabel]);
  return <div className="doku-tenant-field" title={title}>
    <label id={`${id}-label`} htmlFor={id}>{label}</label>
    <Autocomplete
      id={id}
      className="doku-tenant-select"
      options={options}
      value={selected}
      onChange={(event, option, reason) => {
        if (reason === "clear" && event.type === "change") return;
        onChange(option?.id || "");
      }}
      onInputChange={(_, next) => setInput(next)}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, candidate) => option.id === candidate.id}
      filterOptions={(items, { inputValue }) => {
        const query = inputValue.trim().toLocaleLowerCase();
        // Beim Öffnen bleibt die gesamte Liste sichtbar, auch mit vorausgewähltem Wert.
        if (inputValue === selected?.label) return items;
        return items.filter(item => `${item.label} ${item.id}`.toLocaleLowerCase().includes(query));
      }}
      renderOption={(props, option) => <li {...props} key={option.id}>
        <span className="doku-tenant-option">
          <span>{option.label}</span>
          {options.some(other => other.id !== option.id && other.label === option.label) && <small>{option.id}</small>}
        </span>
      </li>}
      renderInput={params => <TextField {...params} placeholder={placeholder} />}
      disabled={disabled}
      loading={loading}
      loadingText={t("quelle.laedt")}
      noOptionsText={input ? t("quelle.auswahlKeinTreffer") : t("quelle.auswahlLeer")}
      openText={t("quelle.auswahlOeffnen")}
      closeText={t("quelle.auswahlSchliessen")}
      clearText={t("quelle.auswahlLeeren")}
      openOnFocus
      selectOnFocus
      clearOnBlur
      autoHighlight
      autoSelect={false}
      disablePortal
    />
  </div>;
}
